import React from 'react';
import { Glow, Outlined, Solid, Text } from './Button.styles';

const ButtonVariants = {
  outlined: Outlined,
  solid: Solid,
  glow: Glow,
  text: Text,
};

export interface ButtonProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  children?: React.ReactNode;
  variant?: keyof typeof ButtonVariants;
  size?: 'xs' | 'sm' | 'md';
}

export function Button({
  variant = 'outlined',
  children,
  size = 'md',
  ...rest
}: ButtonProps) {
  const SelectedVariant = ButtonVariants[variant];

  return (
    <SelectedVariant type="button" $size={size} {...rest}>
      {children}
    </SelectedVariant>
  );
}
